import { render, staticRenderFns } from "./LongComicPage.vue?vue&type=template&id=00bc7ba4"
import script from "./LongComicPage.vue?vue&type=script&lang=js"
export * from "./LongComicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports